"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ReactNode, useEffect } from "react";
import { Toaster } from "sonner";
import Analytics from "@/components/analytics";
import Adsense from "./adsense";
import SignModalPortal from "@/components/sign/modal-portal";

export function ThemeProvider({
  children,
  locale,
  authEnabled,
  analyticsId,
}: {
  children: ReactNode;
  locale: string;
  authEnabled: boolean;
  analyticsId?: string;
}) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.lang = locale;
    }
  }, [locale]);

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme={process.env.NEXT_PUBLIC_DEFAULT_THEME || "system"}
      enableSystem
      disableTransitionOnChange
      value={{ light: "light", dark: "dark" }}
    >
      {children}

      <Toaster position="top-center" richColors />
      <Analytics locale={locale} analyticsId={analyticsId} />

      {authEnabled && <SignModalPortal />}

      <Adsense />
    </NextThemesProvider>
  );
}
